module.exports = __webpack_public_path__ + "img/whatsapp.1eb28f09.png";